<template>
	<div ref="loadMoreTrigger" class="footer-load-placeholder">
		<div v-if="more" class="cell">{{ $t('enterprise.loading') }}</div>
	</div>
</template>

<script setup>
import { ref, watch, onBeforeUnmount, nextTick } from 'vue';

const props = defineProps({
	more: {
		type: Boolean,
		default: false
	}
});

const emit = defineEmits(['loadMore']);

const loadMoreTrigger = ref(null);
let observer = null;
let moreLoadingIng = false;

const setupIntersectionObserver = () => {
	const _observer = new IntersectionObserver(
		entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// 当元素进入视口时触发加载更多数据
					loadMoreData();
				}
			});
		},
		{ threshold: 0 }
	); // 可调整阈值以控制元素在视口中的位置比例

	// 开始观察指定的DOM元素
	if (loadMoreTrigger.value) {
		_observer.observe(loadMoreTrigger.value);
		observer = _observer;
	}
};

const loadMoreData = () => {
	if (!props.more) return;
	if (moreLoadingIng) return;
	moreLoadingIng = true;
	emit('loadMore', () => {
		moreLoadingIng = false;
	});
};

const destroy = () => {
	if (observer && loadMoreTrigger.value) {
		observer.unobserve(loadMoreTrigger.value);
		observer = null;
	}
};
onBeforeUnmount(() => {
	destroy();
});

// 监听 moreData 变化
watch(
	() => props.more,
	val => {
		if (val) {
			destroy();
			nextTick(() => {
				setupIntersectionObserver();
			});
		}
	},
	{ immediate: true }
);
</script>

<style lang="less" scoped>
.footer-load-placeholder {
	text-align: center;

	.cell {
		padding: 0.08rem;
		color: #666;
		/* 12/B1-regular */

		font-size: 0.12rem;

		font-weight: 400;
		line-height: 140%; /* 16.8px */
	}
}
</style>
